import React from 'react';
import { Button } from 'clad';

class GreenButton extends React.PureComponent {
    render() {
        const { props } = this;
        let className = 'ant-btn-green';

        if (props.className != null) {
            className += ` ${props.className}`;
        }

        return <Button {...props} className={className} />;
    }
}

GreenButton.Group = Button.Group;
export default GreenButton;
